export const getStyles = (isSticky: boolean) => ({
  containerSx: {
    ...(isSticky && {
      borderBottom: '1px solid',
    }),
    borderColor: 'borderBase',
    transition: 'border 0.2s',
    justifyContent: 'center',
    mx: -6,
    position: 'sticky',
    bg: 'surface1',
    zIndex: 1,
    top: 0,
    py: 2,
  },
  getAvatarGroupSx: (zIndex: number) => ({
    minW: 8,
    '.chakra-avatar__excess': {
      zIndex,
      color: 'textSubdued',
      fontSize: 'xs',
      fontWeight: 500,
      border: '1px solid',
      borderColor: 'M.10',
      backgroundColor: 'white',
      width: '32px',
      height: '32px',
      left: '12px',
    },
    '.chakra-avatar': {
      marginInlineEnd: '-5px',
    },
  }),
  avatarSx: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'M.10',
    '.chakra-avatar__initials': {
      fontSize: 'xs',
    },
  },
  avatarBadgeSx: {
    left: '-3px',
    bottom: '1px',
    boxSize: '10px',
    border: '0.5px solid',
    borderColor: 'M.10',
  },
});
